import React from "react";
import PropTypes from "prop-types";

const HighlightedText = ({ text = "", highlighted = "" }) => {
  const highlightStartIndex = text
    .toLowerCase()
    .indexOf(highlighted.toLowerCase());
  const highlightEndIndex = highlightStartIndex + highlighted.length - 1;

  return (
    <React.Fragment>
      {highlightStartIndex !== 0 && (
        <strong>{text.substring(0, highlightStartIndex)}</strong>
      )}
      {text.substring(highlightStartIndex, highlightEndIndex + 1)}
      {highlightEndIndex !== text.length - 1 && (
        <strong>{text.substring(highlightEndIndex + 1)}</strong>
      )}
    </React.Fragment>
  );
};

HighlightedText.propTypes = {
  highlighted: PropTypes.string,
  text: PropTypes.string,
};

export default HighlightedText;
